"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _basil = _interopRequireDefault(require("basil.js"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// list of authorized cookies from CCM, Telemed and mystrength application that should not be deleted
const authorizedCookies = ['_member_session',
// CCM & Telemed
'access_token',
// CCM & myS
'browser_timezone',
// CCM & Telemed
'member_auth_token',
// OneApp
'member_id',
// OneApp
'msg_redirect_url',
// CCM & Telemed
'pre_registration_member_id',
// CCM & Telemed
'reauth_token',
// myS
'refresh_token',
// CCM & myS & OneApp
'token' // myS
];

/**
  - list of authorized prefix cookies with special pattern, e.g. _vwo_ + authToken => _vwo_12252022CLTN, should not be deleted
  - details on these cookies, https://confluence.teladoc.net/display/LVGO/Cookie+kill+script
**/
const authorizedCookiePattern = ['__stripe_',
// Stripe
'_pk_',
// Piwik
'_vis_',
// VWO
'_vwo_',
// VWO: CCM
'mp_',
// Mixpanel: CCM & MH
'Optanon',
// OneTrust: CCM
'stg_' // Piwik
];

const TYPES = {
  local: 'localStorage',
  session: 'sessionStorage',
  cookie: 'cookie'
};
const basil = new _basil.default({
  namespace: 'livongo',
  storages: ['local', 'session', 'cookie']
});

/**
 * Utilities for saving and retrieving data from local/session storage.
 * @module StorageUtils
 */
const StorageUtils = {
  /**
   * Sets a value in the selected storage type.
   * @static
   * @function set
   * @param {Object} data - The data to pass.
   * @param {String} data.key - The key to save the value as.
   * @param {*} data.value - The value to set. Values will be run through `JSON.stringify()`.
   * @param {String} [data.type='local'] - The type of storage to use. Available types include 'local', 'session', and 'cookie'.
   * @param {Object} [data.cookieOptions={}] - Options to set on the cookie if the type is set to 'cookie'.
   * @param {Boolean} [data.useNative=false] - Whether to use native storage or the namespaced internal storage.
   * @param {Boolean} [data.stringify=true] - Whether to run the value through JSON.stringify before storing.
   * @example
   * StorageUtils.set({key: 'foo', value: 'bar'});
   * @returns {void}
   */
  set(_ref) {
    let {
      key,
      value,
      type = 'local',
      cookieOptions = {},
      useNative = false,
      stringify = true
    } = _ref;
    const val = stringify ? JSON.stringify(value) : value;
    switch (type) {
      case 'session':
        {
          const options = {
            storages: ['session', 'local']
          };
          useNative ? _basil.default.sessionStorage.set(key, val, options) : basil.set(key, val, options);
          break;
        }
      case 'cookie':
        {
          const options = _objectSpread({
            storages: ['cookie'],
            expireDays: 1
          }, cookieOptions);
          useNative ? _basil.default.cookie.set(key, val, options) : basil.set(key, val, options);
          break;
        }
      case 'local':
      default:
        {
          useNative ? _basil.default.localStorage.set(key, val) : basil.set(key, val);
          break;
        }
    }
  },
  /**
   * Retrieves a value from storage.
   * @static
   * @function get
   * @param {Object} data - The data to pass.
   * @param {String} data.key - The key to retrieve the value of. Values will be parsed using `JSON.parse()`.
   * @param {String} [data.type='local'] - The type of storage to retrieve from. Available types include 'local', 'session', and 'cookie'.
   * @param {Boolean} [data.useNative=false] - Whether to use native storage or the namespaced internal storage.
   * @param {Boolean} [data.parse=true] - Whether to run the value through JSON.parse before retrieving (use for values that were set using stringify).
   * @example
   * StorageUtils.get({key: 'foo'});
   * @returns {String} - The value at the specified key.
   */
  get(_ref2) {
    let {
      key,
      type = 'local',
      useNative = false,
      parse = true
    } = _ref2;
    if (useNative) {
      const value = _basil.default[TYPES[type]].get(key);
      return parse ? JSON.parse(value) : value;
    } else {
      const value = basil.get(key);
      return parse ? JSON.parse(value) : value;
    }
  },
  /**
   * Removes a stored value from storage.
   * @static
   * @function remove
   * @param {Object} data - The data to pass.
   * @param {String} data.key - The key of the value to remove.
   * @param {String} [data.type='local'] - The type of storage to remove from. Available types include 'local', 'session', and 'cookie'.
   * @param {Boolean} [data.useNative=false] - Whether to use native storage or the namespaced internal storage.
   * @example
   * StorageUtils.remove({key: 'foo'});
   * @returns {void}
   */
  remove(_ref3) {
    let {
      key,
      type = 'local',
      useNative = false
    } = _ref3;
    if (useNative) {
      _basil.default[TYPES[type]].remove(key);
    } else {
      basil.remove(key);
    }
  },
  /**
   * Clear all stored values from storage
   * @static
   * @function clear
   * @param {String} type='local' - The type of storage to clear. Available types include 'local', 'session', and 'cookie'.
   * @example
   * StorageUtils.clear();
   * @returns {void}
   */
  clear() {
    let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'local';
    _basil.default[TYPES[type]].reset();
  },
  /**
   * remove cookie from browser if not found in the authorizedCookies & authorizedCookiePattern
   * @static
   * @function deleteUnAuthorizedCookie
   * @example
   * StorageUtils.deleteUnAuthorizedCookie();
   * @returns {void}
   */
  deleteUnAuthorizedCookie() {
    if (typeof document === 'undefined' || typeof document.cookie !== 'string') {
      return;
    }
    const webCookies = document.cookie.split(';');
    for (const cookie of webCookies) {
      var _context;
      const indexOfequal = cookie.indexOf('=');
      const cookieName = (0, _trim.default)(_context = indexOfequal > -1 ? cookie.substring(0, indexOfequal) : cookie).call(_context);
      const isSubCookie = authorizedCookiePattern.some(
      // verify cookieName's subName is inside of the authorizedCookiePattern list
      subCookie => cookieName.includes(subCookie));

      // delete cookie when it is NOT inside of authorizedCookies && authorizedCookiePattern list
      if (!authorizedCookies.includes(cookieName) && !isSubCookie) {
        this.remove({
          key: cookieName,
          type: 'cookie',
          useNative: true
        });
      }
    }
  }
};
var _default = StorageUtils;
exports.default = _default;